<template>
    <v-container fluid fill-height>
        <v-layout v-if="loading" align-center justify-center>
            <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>
        <v-layout v-else>
            <v-flex xs12>
                <v-card>
                    <v-toolbar color="primary" class="white--text">
                        <v-toolbar-title>Pest Classifications</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon dark>style</v-icon>
                    </v-toolbar>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-alert :value="error != null" outline type="error">
                                {{error}}
                            </v-alert>
                        </v-flex>
                        <v-flex xs12 sm3 offset-sm1>
                            <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 offset-sm1>
                            <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-btn color="primary" block @click="showEditAddPestClassification({ IsActive: true, ClassificationTypes: [] })">
                                Add
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout pt-3>
                        <v-flex xs12>
                            <pest-classification-table :search="search" :filteredItems="filteredItems" @edit="showEditAddPestClassification($event)"></pest-classification-table>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog 
            :value="editing"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition">
            <pest-classification-edit 
                v-if="editing"
                :item="editItem"                    
                :submitLoading="loading"
                :submitError="error"
                @submit="handleSubmit"
                @cancel="cancelEdit()">
            </pest-classification-edit>
        </v-dialog>
    </v-container>
</template>
    
<script>
import PestClassificationTable from "@/components/configuration/pestClassifications/PestClassificationTable.vue";
import PestClassificationEdit from "@/components/configuration/pestClassifications/PestClassificationEdit.vue";

import pestConfigurationApi from '@/api/pestConfigurationApi'

export default {
    components: {
        PestClassificationTable: PestClassificationTable,
        PestClassificationEdit: PestClassificationEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            loading: false,
            search: "",
            activeOnly: true,
            editItem: null,
            pestClassifications: [],                
        }
    },
    computed: {
        filteredItems() {
            return this.pestClassifications.filter(c => c.IsActive === this.activeOnly || !this.activeOnly);
        }
    },
    methods: {
        async loadPestClassifications() {
            this.loading = true;
            this.error = null;

            try {
                this.pestClassifications = await pestConfigurationApi.getPestClassifciations();
            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddPestClassification(item) {            
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            if (this.pestClassifications.filter(a => a.Name.trim() === item.Name.trim() && a.PestClassificationID !== item.PestClassificationID).length > 0) {
                this.error = "Classification with the same name already exists."
                return;
            }

            this.loading = true;            

            try {
                let response = {};

                if (item.PestClassificationID > 0) {
                    response = await pestConfigurationApi.updatePestClassification(item);
                } else {                    
                    response = await pestConfigurationApi.addPestClassification(item);
                }                

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }

            await this.loadPestClassifications();
        }
    },
    async created() {
        await this.loadPestClassifications();
    }
}
</script>